import { Schema } from '@effect/schema';
import { Effect, Request, RequestResolver } from 'effect';
import * as Url from '../../../../url';
import { ServerError } from '../errors';
import { PrologRule, PrologRuleId } from '../types';
export class Get extends Request.TaggedClass('@fixtuur/backpack/gavel/prolog-rule/get') {
}
const decodePrologRule = Schema.decodeUnknown(PrologRule);
export const makeGetRequestResolver = (http) => RequestResolver.fromEffect(({ baseUrl, prologRuleId, tenant, token }) => {
    const url = Url.join(baseUrl, `/api/v1/${tenant}/prolog-rules/${prologRuleId}`);
    return http.get(url, { authorization: token }).pipe(Effect.flatMap(res => decodePrologRule(res.body)), Effect.mapError(originalError => new ServerError({ originalError, url: Url.toString(url) })));
});
export class Create extends Request.TaggedClass('@fixtuur/backpack/gavel/prolog-rule/create') {
}
const CreateBody = Schema.Struct({
    rule_id: PrologRuleId,
});
export const makeCreateRequestResolver = (http) => RequestResolver.fromEffect((req) => {
    const url = Url.join(req.baseUrl, `/api/v1/${req.tenant}/prolog-rules`);
    return http
        .post(url, { 'content-type': 'application/json', authorization: req.token }, JSON.stringify({
        name: req.ruleName,
        rule: req.ruleBody,
    }))
        .pipe(Effect.flatMap(res => Schema.decodeUnknown(CreateBody)(res.body)), Effect.map(res => res.rule_id), Effect.mapError(originalError => new ServerError({ originalError, url: Url.toString(url) })));
});
export class Update extends Request.TaggedClass('@fixtuur/backpack/gavel/prolog-rule/update') {
}
export const makeUpdateResolver = (http) => RequestResolver.fromEffect(({ baseUrl, ruleBody, ruleId, ruleName, tenant, token }) => {
    const url = Url.join(baseUrl, `/api/v1/${tenant}/prolog-rules/${ruleId}`);
    return http
        .put(url, { 'content-type': 'application/json', authorization: token }, JSON.stringify({ body: ruleBody, name: ruleName }))
        .pipe(Effect.flatMap(() => Effect.void), Effect.mapError(originalError => new ServerError({ originalError, url: Url.toString(url) })));
});
